import React, { useRef, useState, useEffect } from "react";
import { Table, Empty, Skeleton } from 'antd';
import { NavLink as Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { useSelector, useDispatch } from 'react-redux';
import { IMAGES } from '../../params';
import { 
    getOrganizationRating
} from '../../API/organization';

export const Rating = () => {
  const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [paginationSize, setPaginationSize] = useState(10);
    const app_global = useSelector(state => state.app_global);
    const organization = useSelector(state => state.organization);
    
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
        await getOrganizationRating({},dispatch)
        .then(async json => {
            console.log ( `%c [API]: [getOrganizationRating]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    function decnum (a,b) { let cases=[2,0,1,1,1,2];return b[(a%100>4 && a%100<20)?2:cases[(a%10<5)?a%10:5]]; }

    const columns = [
        {
            title: 'Медицинское учреждение',
            dataIndex: 'orgname',
            key: 'orgname',
            align: 'left',
            width: 300,
            render: (text, record, index) => <Link to={`/org/${record.id}`} exact={ true } onClick={() => scroll.scrollToTop()} className="org_name"><span className="number">{`${(page - 1) * paginationSize + index + 1}`}</span><span>{`${text}`}</span></Link>
        },
        {
            title: 'Рейтинг',
            dataIndex: 'review_rating',
            key: 'review_rating',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div className="org_rating"><span>{`${text}`}</span></div>
        },
        {
            title: 'Средняя оценка',
            dataIndex: 'review_rate',
            key: 'review_rate',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div className="org_rating_average"><span>{`${text}`}</span></div>
        },
        {
            title: 'Количество отзывов за все время',
            dataIndex: 'review_count',
            key: 'review_count',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div className="org_rating_count"><span>{`${text} ${decnum(text,[ ' отзыв',' отзыва',' отзывов' ])}`}</span></div>
        },
    ];

    return (
        <>
            <section className='container xs --rating default_padding'>
                <div className='content border'>
                {app_global.loading ?
                    <Skeleton active style={{background:'white'}} />
                :
                    organization.loading ?
                        <Skeleton active style={{background:'white'}} />
                    :
                        <>
                            <Table
                                locale={{ emptyText: <Empty description="Список пуст" />}}
                                dataSource={organization.organization_rating} 
                                columns={columns}
                                pagination={{
                                    onChange(current, pageSize) {
                                        setPage(current);
                                        setPaginationSize(pageSize)
                                    },
                                    defaultPageSize: 10, 
                                    hideOnSinglePage: true,
                                }}
                            />
                        </>
                }
                </div>
            </section>
            <section className='content banner --rating'>
                <img className='pc' src={`${IMAGES}/banners/rating.svg`} />
                <img className='mob' src={`${IMAGES}/banners/rating.jpeg`} />
            </section>
        </>
    );
};